import React, { Component } from 'react';
import { Container, NickName, Text, Div, Button, CreateAt, Input, Profile } from './Comment.style';
import { connect } from 'react-redux';
import i18n from '../../../i18n';
import dayjs from 'dayjs';

class Comment extends Component {
    handleKeyPress = (e,commentInfo) => {
        if (e.key === "Enter") {
            this.props.onCommnetConfrim(commentInfo)
        }
    }
    render() {
        let { commentInfo, lang, onModify, onRemove, onReport, currentUser, 
            selectedComment,
            changeModityTextInput,
            onCommentCancel,
            onCommnetConfrim,
            isModify,
            modifyComment,
            onClickNickname
        } = this.props;
        const { id, username ,comment ,date, userid, profileURL, userShareId } = commentInfo;
        return (
            <Container>
                <Div margin={"0 0 0 0"}>
                    <Div width={'calc(100% - 30px)'} justifyContent="flex-start" onClick={() => { onClickNickname(userShareId, userid) }} > 
                        <Profile
                            src={profileURL ? profileURL : "https://front.videomonster.com/images-7cuytg20/common/v2-profile.svg"}
                            alt="icon-profile"
                        />
                        <NickName>{username}</NickName>
                    </Div>
                    {
                            currentUser && currentUser._id === userid ?
                                selectedComment ===  id && isModify? 
                                <Div>
                                    <Button onClick={() => onCommentCancel(commentInfo)} margin={"0 10px 0 0"}>{i18n.t("global.cancel")}</Button>
                                    <Button onClick={() => onCommnetConfrim(commentInfo)}>{i18n.t("global.confirm")}</Button>
                                </Div>
                                :
                                <Div>
                                    {/* <Button onClick={() => {
                                        onModify(commentInfo)
                                    }} margin={"0 10px 0 0"}>{i18n.t("web.gallery.modify")}</Button> */}
                                    <Button onClick={() => onRemove(commentInfo)}>
                                        <img src="https://front.videomonster.com/images-7cuytg20/web/myvideofooter/outline-delete.svg" alt="deleteIcon"></img>
                                    </Button>
                                </Div>
                                :
                                <Div> <Button width={"12px"} onClick={() => onReport(commentInfo)}> <img  src="https://front.videomonster.com/images-7cuytg20/web/sharedLinkPage/reportIcon.png" alt="deleteIcon"></img></Button></Div>
                        }
                </Div>
                <Div margin={"5px 0 2px 0"}>
                    {
                       (currentUser && currentUser._id === userid) && (selectedComment ===  id) && (isModify) ? <Input onKeyPress={(e) => this.handleKeyPress(e,commentInfo)} value={modifyComment} type="text" placeholder={comment} onChange = {changeModityTextInput} maxLength ={200}></Input> : <Text>{comment}</Text>
                    }
                </Div>
                <Div>
                    <CreateAt>{dayjs(date).format("YY.MM.DD")}</CreateAt>
                </Div>
            </Container>
        );
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang,

})

export default connect(
    mapStateToProps,
    null
)(Comment)